import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'

import { cn } from '../../../../lib/utils'
import { RichTextEditorContext } from '../state'

import { ToolText } from './tool'
import { Variable } from './variable'

export const MentionList = forwardRef<HTMLDivElement, { items: any[] }>(
  (props, ref) => {
    const { variables: variableItems, tools: toolsItems } = useContext(
      RichTextEditorContext,
    )
    const [selectedIndex, setSelectedIndex] = useState(0)
    const containerRef = useRef<HTMLDivElement>(null)
    const allItems = [...variableItems, ...toolsItems]

    const filteredItems = allItems.filter((item) => {
      if (props.items[0].label) {
        return item.label
          .toLowerCase()
          .includes(props.items[0].label.toLowerCase())
      }

      return true
    })

    const selectItem = (index: number) => {
      const item = filteredItems[index]

      if (item) {
        // @ts-ignore
        props.command({ id: item.id, label: item.label, type: item.type })
      }
    }

    const scrollToIndex = (index: number) => {
      if (containerRef.current) {
        const container = containerRef.current
        const item = container.children[index] as HTMLElement
        if (item) {
          const itemTop = item.offsetTop
          const itemBottom = itemTop + item.offsetHeight
          const containerTop = container.scrollTop
          const containerBottom = containerTop + container.offsetHeight

          if (itemTop < containerTop) {
            container.scrollTop = itemTop
          } else if (itemBottom > containerBottom) {
            container.scrollTop = itemBottom - container.offsetHeight
          }
        }
      }
    }

    const upHandler = () => {
      const newIndex =
        (selectedIndex + filteredItems.length - 1) % filteredItems.length
      scrollToIndex(newIndex)
      setSelectedIndex(newIndex)
    }

    const downHandler = () => {
      const newIndex = (selectedIndex + 1) % filteredItems.length
      scrollToIndex(newIndex)
      setSelectedIndex(newIndex)
    }

    const enterHandler = () => {
      selectItem(selectedIndex)
    }

    useEffect(() => setSelectedIndex(0), [])

    // @ts-ignore
    useImperativeHandle(ref, () => ({
      onKeyDown: ({ event }: { event: KeyboardEvent }) => {
        if (event.key === 'ArrowUp') {
          upHandler()
          return true
        }

        if (event.key === 'ArrowDown') {
          downHandler()
          return true
        }

        if (event.key === 'Enter') {
          enterHandler()
          return true
        }

        return false
      },
    }))

    return (
      <div
        className="dropdown-menu -mt-s flex max-h-80 flex-col items-start overflow-y-scroll rounded-md border bg-surface-card"
        ref={containerRef}
      >
        {filteredItems.length ? (
          filteredItems.map((item, index) => (
            <button
              className={cn(
                'p-s block w-full border-l-2 text-left',
                index === selectedIndex && 'border-primary bg-neutral-hover',
              )}
              key={item.id}
              onClick={() => selectItem(index)}
              type="button"
            >
              {item.type === 'variable' ? (
                <Variable>{item.label}</Variable>
              ) : (
                <ToolText>{item.label}</ToolText>
              )}
            </button>
          ))
        ) : (
          <div className="font-input-s p-s block w-full border-l-2 text-left">
            No result
          </div>
        )}
      </div>
    )
  },
)

MentionList.displayName = 'MentionList'
